import script from "./CreateAccountPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateAccountPage.vue?vue&type=script&setup=true&lang=js"

import "./CreateAccountPage.vue?vue&type=style&index=0&id=342bcb84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-342bcb84"]])

export default __exports__